<template>
  <div :key="reRender">
    <div class="pb-8">
      <zt-input
        disabled
        outlined
        :label="$t('message.documentDetail.dataFile.id')"
        v-model="dataFileModel.id"
      />
    </div>
    <div class="pb-8">
      <zt-input
        disabled
        outlined
        :label="$t('message.documentDetail.dataFile.date')"
        v-model="dataFileModel.fecha"
      />
    </div>
    <div class="pb-8">
      <zt-input
        disabled
        outlined
        :label="$t('message.documentDetail.dataFile.filename')"
        v-model="dataFileModel.nombre"
      />
    </div>
    <div class="pb-8">
      <zt-input
        disabled
        outlined
        :label="$t('message.documentDetail.dataFile.origin')"
        v-model="dataFileModel.origen"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'DataFile',
  inject: ['stateDetailStore'],
  data() {
    return {
      dataFileModel: {
        id: '',
        nombre: '',
        fecha: '',
        origen: ''
      },
      reRender: 0
    }
  },
  created() {
    this.dataFileModel = {
      ...this.stateDetailStore.detail.dataFile,
      origen: this.getUploadType(this.stateDetailStore.detail.dataFile.origen),
      fecha: this.formatDate(this.stateDetailStore.detail.dataFile.fecha)
    }
    this.reRender += 1
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return moment(date).format('DD/MM/YY HH:mm:ss')
    },
    getUploadType(origin) {
      if (!origin) return ''
      return this.$t(`message.documentDetail.uploadTypes.${origin}`)
    }
  }
}
</script>

<style lang="scss" scoped></style>
